import { connect } from 'react-redux';
import CustomerPage from '../components/CustomerPage';
import {
    getCustomer,
    getCustomerTokens,
    openDeleteCustomerModal,
    deleteCustomer,
    closeDeleteCustomerModal,
    openChangeCustomerIdModal,
    closeChangeCustomerIdModal,
    changeCustomerId
} from '../actions';
import {
    getCustomerSelector,
    getTokensSelector,
    deleteCustomerModalOpenSelector,
    changeCustomerIdModalOpenSelector,
    getIsNotFoundSelector,
    getChangeCustomerIdErrorSelector
} from '../selectors';
import { State } from '../../../reducer';

const mapStateToProps = (state: State) => ({
    customer: getCustomerSelector(state),
    tokens: getTokensSelector(state),
    deleteCustomerModalOpen: deleteCustomerModalOpenSelector(state),
    changeCustomerIdModalOpen: changeCustomerIdModalOpenSelector(state),
    isNotFound: getIsNotFoundSelector(state),
    changeCustomerIdError: getChangeCustomerIdErrorSelector(state),
});

const mapDispatchToProps = {
    getCustomer,
    getCustomerTokens,
    openDeleteCustomerModal,
    closeDeleteCustomerModal,
    openChangeCustomerIdModal,
    closeChangeCustomerIdModal,
    deleteCustomer,
    changeCustomerId,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerPage);
